// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FieldGroup-module__root--kUhPA {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  gap: 13px;
}

.FieldGroup-module__orientation-horizontal--AKg7T {
  flex-direction: row;
  align-items: flex-start;
}

.FieldGroup-module__orientation-horizontal--AKg7T > .ui-Field {
  min-width: 0;
  flex: 1 1 0;
}

.FieldGroup-module__orientation-vertical--fzQ0U {
  flex-direction: column;
  align-items: stretch;
}

.FieldGroup-module__root--kUhPA > .ui-Field {
  margin-top: 0;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/FieldGroup/FieldGroup.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".root {\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  gap: 13px;\n}\n\n.orientation-horizontal {\n  flex-direction: row;\n  align-items: flex-start;\n}\n\n.orientation-horizontal > :global(.ui-Field) {\n  min-width: 0;\n  flex: 1 1 0;\n}\n\n.orientation-vertical {\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.root > :global(.ui-Field) {\n  margin-top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `FieldGroup-module__root--kUhPA`,
	"orientation-horizontal": `FieldGroup-module__orientation-horizontal--AKg7T`,
	"orientation-vertical": `FieldGroup-module__orientation-vertical--fzQ0U`
};
export default ___CSS_LOADER_EXPORT___;
